<template>
  <div class="job-category">
    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.vehicle_name" label="Vehicle Name"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.organisation" label="Organisation"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.group" label="Group"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.vehicle_make" label="Make"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.vehicle_model" label="Model"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.vehicle_year" label="Year"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.vehicle_vin" label="VIN"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.install_tag" label="Install Tag"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { Logger } from "aws-amplify"
const logger = new Logger("Advanced Search / Vehicles")

export default {
  name: 'Jobs',
  props: {
    reset: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      searching: false,
      search: {
        vehicle_name: '',
        organisation : '',
        vehicle_vin: '',
        vehicle_make: '',
        vehicle_model: '',
        vehicle_year: '',
        install_tag: '',
        group: ''
      }
    }
  },
  watch: {
    search: {
      handler(val) {
        this.$emit('updatedSearchCriteria', val)
      },
      deep: true
    },
    reset() {
      this.resetFields();
    }
  },
  mounted() {
  },
  methods: {
    resetFields() {
      logger.info('clear them fields')

      for (var key in this.search) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = '';
        }
      }
      this.search.taskType = 'all'
    }
  }
}
</script>